import { Fragment } from "react";

import { ImageURL } from "../../Global";

export default function CustomInputForm({ Label, isRequired, Type, DocAva }) {
    return (
        <Fragment>
            <label>
                {Label ? Label : '-'} {Type === 'Document' && DocAva ?
                    (<span
                        style={{
                            color: "blue",
                            cursor: "pointer",
                            verticalAlign: "super",
                        }}
                        onClick={() =>
                            window.open(`${ImageURL.Base}/${DocAva}`, "_blank")
                        }
                    >
                        preview
                    </span>)
                    : isRequired ?
                        (<span style={{ color: "red" }}>*</span>)
                        : <Fragment />}
            </label>
        </Fragment>
    )
}